import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import theme from 'styles/theme'
import { Title26 } from 'components/Typography'
import { getBGColor } from 'utils/themeUtils'

export const EventPromoWrapper = styled.div`
  color: ${theme.colors.sagedark};
  margin: 0 40px;
  position: relative;

  ${theme.mediaQueries.medium} {
    margin: 0 auto;
  }
`

export const EventPromoImage = styled(GatsbyImage)`
  height: 360px;
  width: 100%;

  ${theme.mediaQueries.medium} {
    height: auto;
    max-height: 587px;
  }
`

export const EventPromoInfo = styled.div`
  padding: ${theme.space[4]} 0;
  text-align: center;

  ${theme.mediaQueries.medium} {
    background: ${getBGColor()};
    bottom: 0;
    left: 50%;
    margin: 0 auto;
    max-width: 580px;
    padding: 40px 80px 22px;
    position: absolute;
    right: 0;
    transform: translateX(-50%);
  }

  p {
    ${theme.mediaQueries.medium} {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
`

export const EventPromoInfoLabel = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '\\25C6';
    margin: 0 ${theme.space[1]};
    margin-bottom: 1px;
  }
`

export const EventPromoInfoDate = styled.span`
  color: ${theme.colors.sagemedium};
`

export const EventPromoInfoHeader = styled(Title26)`
  ${theme.mediaQueries.medium} {
    margin-top: ${theme.space[4]};
  }
`
